export class AlertBadge extends Konva.Group{
    /**
     * @type {string}
     */
    _text;

    _size;
    _tweenAlertBadge;
    _tweenGroup;
    _tweenText;

    get size() {
        return this._size * this.scaleX();
    }
    set size(value) {
        const scale = value / this._size;
        this.scaleX(scale);
        this.scaleY(scale);
    }
    constructor(text,size,tag, config) {
        super({
            ...config,
            name: `alert_badge ${tag}`,
            listening:false
        });
        this._text = text;
        this._size = size;
        const alertBadge = new Konva.Rect({
            width: this._size,
            height: this._size,
            cornerRadius: (this._size) / 2,
            fill: config && config.fill, // zamiast config?.fill
            draggable: false,
        });
        const infoText = new Konva.Text({
            fontSize: this._size/1.5,
            fontFamily: 'NunitoLight',
            text: "!",
            //width: (this._size/1.5)/2,
            fill: 'white',
            align: 'left',
            wrap: 'none',
            listening: false
        });
        infoText.width(infoText.measureSize("!").width);
        infoText.x((this._size - infoText.width()) / 2);
        infoText.y((this._size - infoText.height()) / 2);
        this.add(alertBadge);
        this.add(infoText);
    }

    initTween() {
        this.listening(true);
        const infoText = this.findOne('Text');
        const alertBadge = this.findOne('Rect');
        const textStartWidth = infoText.width();
        infoText.text("! " + this._text);
        const textEndWidth = infoText.measureSize(" " + this._text).width;

        this._tweenGroup = new Konva.Tween({
            node: this,
            duration: 0.5,
            offsetX: (infoText.x() * 2 + textStartWidth + textEndWidth) - alertBadge.width(),
            easing: Konva.Easings.EaseInOut
        });
        this._tweenAlertBadge = new Konva.Tween({
            node: alertBadge,
            duration: 0.5,
            width: infoText.x()*2 + textStartWidth + textEndWidth,
            easing: Konva.Easings.EaseInOut
        });  
        this._tweenText = new Konva.Tween({
            node: infoText,
            duration: 0.5,
            width: textStartWidth + textEndWidth,
            easing: Konva.Easings.EaseInOut
        });
        this.on('mouseover', this.onMouseOver);
        this.on('mouseout', this.onMouseOut);
        //this.on('click tap', () => { this.getStage().fire('click tap') });
    }

    onMouseOver() {
        this._tweenGroup.play();
        this._tweenAlertBadge.play();
        this._tweenText.play();
        this.getParent().findOne('.image_placeholder').fire('mouseover');  
    }

    onMouseOut() {
        this._tweenText.reverse();
        this._tweenGroup.reverse();
        this._tweenAlertBadge.reverse();
        this.getParent().findOne('.image_placeholder').fire('mouseout');
    }

    destroy() {
        if (this._tweenGroup) {
            this._tweenAlertBadge.destroy();
            this._tweenGroup.destroy();
            this._tweenText.destroy();
            this.off('mouseover', this.onMouseOver);
            this.off('mouseout', this.onMouseOut);
        }
        
        super.destroy();
    }
}
 